import type {
  CreateOrgAdminKeyRequest,
  CreateOrgAdminKeyResponse,
  ListOrgAdminKeysResponse,
  OrgAdminKeySummary,
} from '@nadoutong/contracts';
import { platformApiRequest } from './client.ts';

/**
 * Session CRUD for org management keys (`/v1/org/admin-keys`).
 *
 * Plaintext exists only on the create response. The list never returns it.
 * Every function takes `fetchImpl` so tests inject a stub and production
 * callers pass the session provider's fetch.
 */

const BASE_PATH = '/v1/org/admin-keys';

export async function listOrgAdminKeys(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<ListOrgAdminKeysResponse> {
  return platformApiRequest<ListOrgAdminKeysResponse>(BASE_PATH, { signal }, fetchImpl);
}

export async function createOrgAdminKey(
  body: CreateOrgAdminKeyRequest,
  fetchImpl: typeof fetch,
): Promise<CreateOrgAdminKeyResponse> {
  return platformApiRequest<CreateOrgAdminKeyResponse>(
    BASE_PATH,
    { method: 'POST', body },
    fetchImpl,
  );
}

export async function revokeOrgAdminKey(
  id: string,
  fetchImpl: typeof fetch,
): Promise<OrgAdminKeySummary> {
  return platformApiRequest<OrgAdminKeySummary>(
    `${BASE_PATH}/${encodeURIComponent(id)}`,
    { method: 'DELETE' },
    fetchImpl,
  );
}
